export const KEYS = {
  WALLET_ADDRESS: 'WALLET_ADDRESS',
}
